<!-- Copied from BtnColor.vue and Modified.by.KWShin.2024.01.03. -->

<template>
  <v-menu v-model="show" :close-on-content-click="false" offset-y transition="slide-y-transition">
    <template v-slot:activator="{ on }">
      <v-btn x-small block :color="color" v-on="on">{{ color }}</v-btn>
    </template>
    <v-card id="cp-wrapper" class="mx-auto" style="margin-top:4px">
      <v-color-picker :value="value" hide-canvas hide-mode-switch hide-sliders hide-preview :mode.sync="mode" show-swatches swatches-max-height="250" @update:color="updateColor"></v-color-picker>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '#FFFFFF',
    },
    showWrapper: Boolean,
  },
  data: () => ({
    show: false,
    mode: 'hexa',
    hideSliders: true,
  }),
  computed: {
    color: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    showWrapper: {
      immediate: true,
      handler: 'showWrapperHandler',
    },
  },
  methods: {
    showWrapperHandler(show) {
      if (show) {
        this.color = this.value;
      }
    },
    select(c) {
      this.color = c;
      this.show = false;
    },
    updateColor(color) {
      this.color = color.hex;
    },
  },
};
</script>

<style>
/*
  v-color-picker의 Props 'hide-sliders' 설정이 먹질 않아 style로 강제로 보이지 않게 하였다.
  또한, 여백이 너무 커서 적절히 조정하였다.
  Added.by.KWShin.2024.01.03. 
*/
div#cp-wrapper div.v-color-picker__controls {
  padding: 0px 16px 0px 16px;
}
div#cp-wrapper div.v-color-picker__preview {
  display: none;
}
div#cp-wrapper div.v-color-picker__edit {
  margin-top: 16px;
}
</style>
